(() => {
  const focusableSelector = 'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function resetGuide(modal) {
    const scroller = modal.querySelector('[data-clayan-size-guide-scroll]');
    if (scroller) scroller.scrollTop = 0;
    modal.querySelectorAll('[data-clayan-size-measure]').forEach((details) => {
      details.open = false;
    });
  }

  function setTab(modal, target) {
    modal.querySelectorAll('[data-clayan-size-tab]').forEach((tab) => {
      const active = tab.dataset.clayanSizeTab === target;
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    modal.querySelectorAll('[data-clayan-size-panel]').forEach((panel) => {
      panel.hidden = panel.dataset.clayanSizePanel !== target;
    });
  }

  function openModal(modal, trigger) {
    if (!modal) return;
    modal._clayanTrigger = trigger;
    setTab(modal, modal.dataset.defaultTab || 'woman');
    resetGuide(modal);
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('clayan-size-guide-open');
    window.requestAnimationFrame(() => {
      const close = modal.querySelector('[data-clayan-size-guide-close].clayan-size-guide__close');
      if (close) close.focus();
    });
  }

  function closeModal(modal) {
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('clayan-size-guide-open');
    resetGuide(modal);
    if (modal._clayanTrigger) modal._clayanTrigger.focus();
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-clayan-size-guide-open]');
    if (trigger) {
      event.preventDefault();
      openModal(document.getElementById(trigger.getAttribute('aria-controls')), trigger);
      return;
    }

    const close = event.target.closest('[data-clayan-size-guide-close]');
    if (close) {
      closeModal(close.closest('[data-clayan-size-guide]'));
      return;
    }

    const tab = event.target.closest('[data-clayan-size-tab]');
    if (tab) {
      const modal = tab.closest('[data-clayan-size-guide]');
      setTab(modal, tab.dataset.clayanSizeTab);
      resetGuide(modal);
    }
  });

  document.addEventListener('keydown', (event) => {
    const modal = document.querySelector('[data-clayan-size-guide].is-open');
    if (!modal) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      closeModal(modal);
      return;
    }

    if (event.key === 'Tab') {
      const focusables = Array.from(modal.querySelectorAll(focusableSelector)).filter((el) => el.offsetParent !== null);
      if (!focusables.length) return;
      const first = focusables[0];
      const last = focusables[focusables.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  });
})();
